import { createSlice } from '@reduxjs/toolkit'
import { getEmployeesWithPagination, retrieveEmployees, searchEmployees } from './employeesThunk'

const defaultActiveSort = 'LAST_ADDED'
const defaultPageSize = 10

const initialState = {
  pageNumber: 0,
  summaries: {},
  sortBy: ['LAST_ADDED', 'LAST_UPDATED', 'NAME', 'Name_TRANSLATED'],
  activeSort: defaultActiveSort,
  value: [],
  loading: false,
  finalPage: true,
  alert: {},
  filterList: [],
  activeFilters: [],
  pageSize: defaultPageSize,
  activeSearch: '',
  data: [],
  lookups: {},
  updatedItem: {},
}

const employeesSlice = createSlice({
  name: 'employees',
  initialState,

  extraReducers: {
    [retrieveEmployees.pending]: (state) => {
      state.loading = true
    },

    [retrieveEmployees.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [retrieveEmployees.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.value = payload
      state.finalPage = payload?.length < state.pageSize
    },

    [getEmployeesWithPagination.pending]: (state) => {
      state.loading = true
    },
    [getEmployeesWithPagination.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [getEmployeesWithPagination.fulfilled]: (state, { payload }) => {
      state.loading = false

      state.value = payload.pageNumber === 0
        ? payload.response : [...state.value, ...payload.response]
      state.finalPage = payload.response?.length < state.pageSize
      state.pageNumber = payload.pageNumber
      state.alert = {}
      state.activeSearch = ''
    },

    [searchEmployees.pending]: (state) => {
      state.loading = true
    },
    [searchEmployees.rejected]: (state, { payload }) => {
      state.loading = false
      state.alert = payload
    },
    [searchEmployees.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.value = payload.response
      state.finalPage = payload.response?.length < state.pageSize
      state.pageNumber = 0
      state.alert = {}
      state.activeSearch = payload.activeSearch
    },

  },
})

export const selectEmployees = ({ employees }) => employees
export const { activeSummaryHandler } = employeesSlice.actions

export default employeesSlice.reducer
